import { createCrudSlice, createCrudSelectors } from './CrudRedux'

const stateValuesSlice = createCrudSlice({
  name: 'stateValues',
})

export const StateValuesActions = stateValuesSlice.actions

export const StateValuesSelectors = {
  ...createCrudSelectors({ name: 'stateValues' }),
}

export default stateValuesSlice.reducer